import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=3902ea9f&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=js&"
export * from "./app-header.vue?vue&type=script&lang=js&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=3902ea9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902ea9f",
  null
  
)

export default component.exports